import ConstituentSearchColumn from '../ConstituentSearchColumn';
import LabelResourceTypes from '../labels/LabelResourceTypes';

const FilterParams = Object.freeze({
  advancedFilters: {
    type: JSON,
    defaultValue: [],
  },
  columns: {
    type: Array,
    defaultValue: [
      ConstituentSearchColumn.DISPLAY_NAME,
      ConstituentSearchColumn.DEVELOPERS,
      ConstituentSearchColumn.CONSTITUENT_RULES,
      ConstituentSearchColumn.CONSTITUENT_CATEGORIES,
      ConstituentSearchColumn.LAST_INTERACTION_DATE,
      ConstituentSearchColumn.PRIMARY_PHONE,
      ConstituentSearchColumn.PRIMARY_EMAIL,
      ConstituentSearchColumn.IS_DECEASED,
    ],
  },
  customFieldColumns: {
    type: Array,
    defaultValue: [],
  },
  donationAgg: {
    type: Boolean,
    defaultValue: null,
  },
  filterName: {
    type: String,
    defaultValue: null,
  },
  filters: {
    type: JSON,
    defaultValue: [],
  },

  // TODO(jon): Properties below are for old constituent search only and will be removed.
  birthdayMonth: {
    type: Number,
    defaultValue: null,
  },
  bornAfterDate: {
    type: Date,
    defaultValue: null,
  },
  bornBeforeDate: {
    type: Date,
    defaultValue: null,
  },
  city: {
    type: String,
    defaultValue: null,
  },
  connectionConstituentId: {
    type: String,
    defaultValue: null,
  },
  constituentCategories: {
    type: Array,
    defaultValue: [],
  },
  constituentRules: {
    type: Array,
    defaultValue: [],
  },
  constituentType: {
    type: String,
    defaultValue: null,
  },
  dateType: {
    type: String,
    defaultValue: null,
  },
  donationPlanCadence: {
    type: String,
    defaultValue: null,
  },
  donationTypes: {
    type: Array,
    defaultValue: [],
  },
  endDate: {
    type: Date,
    defaultValue: null,
  },
  labelIds: {
    type: Array,
    defaultValue: [],
  },
  labels: {
    type: Array,
    defaultValue: [],
  },
  labelResourceType: {
    type: String,
    defaultValue: LabelResourceTypes.CNX,
  },
  maxDonation: {
    type: Number,
    defaultValue: null,
  },
  maxMinutes: {
    type: Number,
    defaultValue: null,
  },
  minDonation: {
    type: Number,
    defaultValue: null,
  },
  minMinutes: {
    type: Number,
    defaultValue: null,
  },
  nameEmailPhone: {
    type: String,
    defaultValue: null,
  },
  postalCode: {
    type: String,
    defaultValue: null,
  },
  startDate: {
    type: Date,
    defaultValue: null,
  },
  state: {
    type: String,
    defaultValue: null,
  },
  userIds: {
    type: String, // TODO(jon): Eventually this should support an array of IDs.
    defaultValue: 'all',
  },
});

export default FilterParams;
